import { routeMap } from 'router';

export const DATE_FORMAT = 'D MMMM YYYY HH:mm';
export const DATE_FORMAT_WITHOUT_TIME = 'D MMMM YYYY';
export const RESPONSE_ATTACHMENT_TYPES = [18, 21, 24, 55, 51, 52, 59];
export const REPORT_STATUS_CODES_FOR_CANCEL = [3, 5, 13];
export const REPORT_STATUS_CODES_FOR_EDIT = [3, 5, 13];
export const CANCEL_ACTION = 'cancel';
export const EDIT_ACTION = 'edit';
export const ADJUSTMENT_CORRECTION_TYPE = 'a';
export const PRIMARY_CORRECTION_TYPE = 'o';
export const CANCEL_CORRECTION_TYPE = 'c';
// Temporary fix with isMovementReport
export const MOVEMENT_REPORT_TITLE = 'Отчет о движении денежных средств';
export const EVENT_TYPES = Object.freeze({
  SNU: 30,
  TU: 31,
  NDFL3: 41,
  OVERPAYMENTS: 42,
  clarifyInfo: 258,
  COURTORDERS: 45,
  UNEXPLAINED_PAYMENTS: 265,
  JUDICIAL_ORDER: 29,
  QES_REQUEST: 110,
  QES_RESPONSE: 111,
  QES_REJECT: 112,
  QES_ERROR: 113,

  RSP_RESPONSE: 277,
  RSP_ERROR: 278,
  RSP_AWAITING_REQUEST: 279,
  RSP_REQUEST: 280,
  RSP_REQUEST_ERROR: 281,

  FOREIGN_BANK_SEND: 267,
  FOREIGN_BANK_GET: 356,

  UNIFIED_SUBSCRIBER: 362,

  INVESTDEDUCTIONS_REJECT: 353,
  ESTATEDEDUCTIONS_REJECT: 354,

  ADMINISTRATIVE_FINE_SEND: 364,
  ADMINISTRATIVE_FINE_GET: 365,

  STAGING_REGISTER: 367,
  REMOVAL_REGISTER: 368,
  NDFL3_EXTENDED: 369,
});
export const EVENT_TYPES_FOR_DOWNLOAD = [
  EVENT_TYPES.SNU,
  EVENT_TYPES.TU,
  EVENT_TYPES.NDFL3,
  EVENT_TYPES.NDFL3_EXTENDED,
  EVENT_TYPES.OVERPAYMENTS,
  EVENT_TYPES.COURTORDERS,
];

export const EVENT_TYPE_TITLE_MAP = {
  [EVENT_TYPES.SNU]: 'Налоговое уведомление',
  [EVENT_TYPES.TU]: 'Требование об уплате',
  [EVENT_TYPES.OVERPAYMENTS]: 'Сообщение о факте излишней оплаты',
  [EVENT_TYPES.NDFL3]:
    'Уведомление о необходимости представления налоговой декларации формы 3-НДФЛ',
  [EVENT_TYPES.NDFL3_EXTENDED]: 'Уведомление о непредставлении налоговой декларации формы 3-НДФЛ',
  [EVENT_TYPES.COURTORDERS]: 'Заявление о вынесении судебного приказа',
  [EVENT_TYPES.UNEXPLAINED_PAYMENTS]: 'Уточнить реквизиты платежа',
  [EVENT_TYPES.JUDICIAL_ORDER]: 'Заявление о вынесении судебного приказа',
};

export const pdfLabel = {
  [EVENT_TYPES.INVESTDEDUCTIONS_REJECT]: 'инвестиционного',
  [EVENT_TYPES.ESTATEDEDUCTIONS_REJECT]: 'имущественного',
};

export const MESSAGE_CARDTYPE_MAP = {
  107: routeMap.openingForeignBankAccount,
  108: routeMap.closingForeignBankAccount,
  15: routeMap.changeAccountProps,
};
